import {
  Alignment,
  Autoformat,
  BlockQuote,
  Bold,
  Bookmark,
  ClassicEditor,
  CodeBlock,
  Emoji,
  Essentials,
  FindAndReplace,
  Font,
  Fullscreen,
  Heading,
  Highlight,
  HorizontalLine,
  Image,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  ListProperties,
  MediaEmbed,
  PageBreak,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  SourceEditing,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  Strikethrough,
  Style,
  Subscript,
  Superscript,
  Table,
  TableColumnResize,
  TableToolbar,
  TodoList,
  Underline,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
import { UploadAdapterPlugin } from "./uploadAdapter";

export const EDITOR_PLUGINS = [
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  Link,
  List,
  ListProperties,
  TodoList,
  BlockQuote,
  CodeBlock,
  Image,
  ImageCaption,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  ImageInsert,
  ImageResize,
  Table,
  TableToolbar,
  TableColumnResize,
  MediaEmbed,
  Alignment,
  Font,
  Highlight,
  Indent,
  IndentBlock,
  FindAndReplace,
  RemoveFormat,
  SourceEditing,
  HorizontalLine,
  PageBreak,
  Bookmark,
  Emoji,
  SpecialCharacters,
  SpecialCharactersEssentials,
  SpecialCharactersText,
  SpecialCharactersCurrency,
  SpecialCharactersMathematical,
  SpecialCharactersArrows,
  SpecialCharactersLatin,
  Style,
  Fullscreen,
  Autoformat,
  PasteFromOffice,
  UploadAdapterPlugin,
];

export const getEditorConfig = (placeholder = "") => ({
  licenseKey: "GPL",
  plugins: EDITOR_PLUGINS,
  toolbar: {
    items: [
      "undo",
      "redo",
      "|",
      "sourceEditing",
      "findAndReplace",
      "fullscreen",
      "|",
      "heading",
      "style",
      "|",
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "subscript",
      "superscript",
      "|",
      "fontSize",
      "fontFamily",
      "fontColor",
      "fontBackgroundColor",
      "highlight",
      "removeFormat",
      "|",
      "alignment",
      "|",
      "bulletedList",
      "numberedList",
      "todoList",
      "|",
      "outdent",
      "indent",
      "|",
      "link",
      "bookmark",
      "blockQuote",
      "codeBlock",
      "|",
      "insertTable",
      "insertImage",
      "mediaEmbed",
      "|",
      "horizontalLine",
      "pageBreak",
      "emoji",
      "specialCharacters",
    ],
    shouldNotGroupWhenFull: true,
  },
  heading: {
    options: [
      { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
      { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
      { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
      { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
      { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
    ],
  },
  style: {
    definitions: [
      {
        name: "Info box",
        element: "p",
        classes: ["info-box"],
      },
      {
        name: "Warning box",
        element: "p",
        classes: ["warning-box"],
      },
      {
        name: "Marker",
        element: "span",
        classes: ["marker"],
      },
      {
        name: "Small text",
        element: "p",
        classes: ["text-small"],
      },
    ],
  },
  image: {
    toolbar: [
      "imageStyle:inline",
      "imageStyle:block",
      "imageStyle:side",
      "|",
      "toggleImageCaption",
      "imageTextAlternative",
      "|",
      "resizeImage",
    ],
    resizeOptions: [
      { name: "resizeImage:original", label: "Original", value: null },
      { name: "resizeImage:25", label: "25%", value: "25" },
      { name: "resizeImage:50", label: "50%", value: "50" },
      { name: "resizeImage:75", label: "75%", value: "75" },
    ],
    resizeUnit: "%",
  },
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "tableProperties",
      "tableCellProperties",
    ],
  },
  codeBlock: {
    languages: [
      { language: "plaintext", label: "Plain text" },
      { language: "html", label: "HTML" },
      { language: "css", label: "CSS" },
      { language: "javascript", label: "JavaScript" },
      { language: "json", label: "JSON" },
    ],
  },
  mediaEmbed: {
    previewsInData: true,
  },
  link: {
    defaultProtocol: "https://",
    decorators: {
      openInNewTab: {
        mode: "manual",
        label: "Open in new tab",
        defaultValue: true,
        attributes: {
          target: "_blank",
          rel: "noopener noreferrer",
        },
      },
    },
  },
  placeholder,
});

export { ClassicEditor };
